/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useMemo, useState } from "react";
import {
  Row,
  Col,
  CardText,
  CardTitle,
  Card,
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { FiShare2, FiBriefcase } from "react-icons/fi";
import { Link } from "react-router-dom";
import { AiFillStar } from "react-icons/ai";
import { BiDotsVerticalRounded, BiExitFullscreen } from "react-icons/bi";
import { MdLocationOn, MdOutlineFeedback } from "react-icons/md";
import SelectRouteModal from "../../components/Modals/SelectRouteModal";
import ShareModal from "../../components/Modals/ShareModal";
import ReportSuggestionModal from "../../components/Modals/ReportSuggestionModal";
import CreateNewRouteModal from "../../components/Modals/CreateNewRouteModal";
import PointsListingModal from "../../components/Modals/PointsListingModal";
import "../../pages/Category/Cemetery/Cemetery.scss";
import NoDataFound from "../../components/NoDataFound/NoDataFound";
import { routeDetail, updateRouteDetail } from "../../services/myRoute.service";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import swal from "sweetalert";
import { removeUserFavorite } from "../../services/favourites.service";
import Pagination from "../../components/Pagination/Pagination";
import UserNotLoggedIn from "../../components/UserNotLoggedIn/UserNotLoggedIn";
import marked_pop from "../../assets/marked_pop.svg";
import {
  IoHeart,
  IoHeartOutline,
  IoHeartSharp,
  IoNavigateSharp,
  IoShareSocial,
} from "react-icons/io5";
import { HiDotsVertical } from "react-icons/hi";
import { FaPlus } from "react-icons/fa";
import { FaLocationDot } from "react-icons/fa6";
// import card_image from "../../assets/card_image.png";
import { categoryItems } from "../Home/Category";

const GridView = ({
  name,
  favourite,
  getFavouriteList,
  totalCount,
  currentPage,
  setCurrentPage,
  pageSize,
  isUserLoggedIn,
}) => {
  const [dropdownMenuOpen, setMenuOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  const [showReportModal, setShowReportModal] = useState(false);
  const [showListModal, setShowListModal] = useState(false);
  const [showCreateRouteModal, setShowCreateRouteModal] = useState(false);
  const [route, setRoute] = useState(null);
  const [routeName, setRouteName] = useState(null);
  const [pointName, setPointName] = useState(null);
  const [totalRecords, setTotalRecords] = useState("");
  const [mkmID, setMkmId] = useState();
  const [link, setLink] = useState("");
  const [showSpinner, setShowSpinner] = useState(false);

  const userName = useSelector(
    (state) => state?.userDetailReducer?.userData?.userName
  );

  useEffect(() => {
    setTotalRecords(totalCount);
  }, [totalCount]);

  const toggle = () => {
    setShowModal(!showModal);
    setRoute(null);
  };

  const currentTableData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * pageSize;
    const lastPageIndex = firstPageIndex + pageSize;
    return favourite?.slice(0, pageSize);
  }, [currentPage, favourite]);

  console.log("klwhqnkfjewq", favourite);

  const createNewRoute = () => {
    setShowModal(false);
    setShowCreateRouteModal(true);
  };

  const addToRoute = (id) => {
    setMkmId(id);
    setShowModal(true);
  };

  const share = (id, poi) => {
    var data;
    if (Object.keys(id)[0] === "tzkim") {
      data = `${window?.location?.protocol}//${window?.location?.host}/category-details/${id?.tzkim}/${poi}`;
      setLink(data);
    } else {
      data = `${window?.location?.protocol}//${window?.location?.host}/category-detail/${id?.mkm}/${poi}`;
      setLink(data);
    }
    setShowShareModal(true);
  };

  const reportSuggestion = (title, id) => {
    setMkmId(id);
    setPointName(title);
    setShowReportModal(true);
  };

  const selectRoute = async () => {
    let existingData;
    if (route?.id) {
      try {
        let response = await routeDetail({
          userName: userName,
          routeID: route?.id,
        });
        if (response && response?.status === 200) {
          existingData = response?.data?.data;
        }

        let requestBody = [];
        if (existingData?.length < 25) {
          if (existingData?.length === 0) {
            requestBody?.push({
              mkmID: mkmID,
              orderNumber: 0,
              visited: false,
            });
          } else if (existingData?.length === 1) {
            requestBody?.push({
              mkmID: existingData[0]?.place?.mkmID,
              orderNumber: 0,
              visited: false,
            });
            requestBody?.push({
              mkmID: mkmID,
              orderNumber: 1,
              visited: false,
            });
          } else {
            existingData?.splice(existingData?.length, 0, {
              mkmID: mkmID,
              orderNumber: existingData?.length,
              visited: false,
            });
            requestBody = existingData?.map((item, i) => {
              return {
                mkmID: item?.place?.mkmID || item?.mkmID,
                orderNumber: i,
                visited: item?.visited,
              };
            });
          }
          try {
            setShowSpinner(true);
            let res = await updateRouteDetail(requestBody, {
              userName: userName,
              routeID: route?.id,
            });
            if (res && res?.status === 200) {
              toast.success("Point Added Successfully In Your Route!", {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 2000,
              });
              setShowSpinner(false);
            }
          } catch (err) {
            toast.error(
              err?.response?.data?.message ||
                "Oops.. something went wrong, try again !!!",
              {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 2000,
              }
            );
            setShowSpinner(false);
          }
          setRoute("");
          setShowModal(false);
        } else {
          toast.warning(
            "Max of only 25 points can be added to a route, Kindly remove a point to add a new point.",
            {
              position: toast.POSITION.TOP_RIGHT,
              autoClose: 2000,
            }
          );
          setShowSpinner(false);
        }
        setRoute("");
        setShowModal(false);
      } catch (error) {
        console.log(error);
        setShowSpinner(false);
      }
    }
    if (!route?.id) {
      toast.error("Please Select The Route.", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 2000,
      });
      setShowSpinner(false);
    }
  };

  const removeFromFavorite = async (item) => {
    const willRemoveFavorite = await swal({
      title: "Are you sure?",
      text: "You want to remove this route from Favorites?",
      icon: marked_pop,
      buttons: true,
    });
    if (willRemoveFavorite) {
      try {
        const obj = {
          userName: userName,
        };
        const data = {
          mkmId: item?.mkmInfo ? item?.mkmInfo?.mkmID : null,
          tzId: item?.tzadikimInfo ? item?.tzadikimInfo?.tzadikimID : null,
        };
        const response = await removeUserFavorite(data, obj);
        if (response && response.status === 200) {
          getFavouriteList();
          swal(
            "Removed!",
            "Your route has been removed from Favorites!",
            "success"
          );
        }
      } catch (error) {
        toast.error(
          error?.response?.data?.message ||
            "Oops.. something went wrong, try again !!!",
          {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 2000,
          }
        );
      }
    }
  };

  useEffect(() => {
    console.log("currentTableData", currentTableData);
  }, [currentTableData]);

  return (
    <div className="grid_view">
      <SelectRouteModal
        route={route}
        setRoute={setRoute}
        showModal={showModal}
        toggle={toggle}
        createNewRoute={createNewRoute}
        selectRoute={selectRoute}
        showSpinner={showSpinner}
      />
      <CreateNewRouteModal
        showCreateRouteModal={showCreateRouteModal}
        setShowCreateRouteModal={setShowCreateRouteModal}
        showListModal={showListModal}
        setShowListModal={setShowListModal}
        routeName={routeName}
        setRouteName={setRouteName}
        pointName={pointName}
        setPointName={setPointName}
      />
      <PointsListingModal
        showListModal={showListModal}
        setShowListModal={setShowListModal}
        setRouteName={setRouteName}
        routeName={routeName}
        pointName={pointName}
        setPointName={setPointName}
      />
      <ReportSuggestionModal
        showReportModal={showReportModal}
        setShowReportModal={setShowReportModal}
        showListModal={showListModal}
        setShowListModal={setShowListModal}
        setRouteName={setRouteName}
        routeName={routeName}
        pointName={pointName}
        mkmID={mkmID}
      />
      <ShareModal
        showShareModal={showShareModal}
        setShowShareModal={setShowShareModal}
        link={link}
        setLink={setLink}
      />

      <div
        className={`item_card ${
          currentTableData?.length <= 2 ? "two-items" : ""
        }`}
      >
        {currentTableData?.length === 0 || currentTableData === undefined ? (
          <NoDataFound />
        ) : (
          currentTableData?.map((place, index) => (
            <div className="grid_card" key={index}>
              <Link
                to={`/category-detail/?tzadikimId=${place?.tzadikimInfo?.tzadikimID}&cor=${place?.tzadikimInfo?.poi}`}
                state={{
                  from: "favourite",
                  categoryName: "Tzadikim",
                  categoryTitle: place?.tzadikimInfo?.tzadikimID && "צדיקים",
                }}
              >
                <div className="card_items">
                  <div className="card_image">
                    <img
                      src={
                        place?.mkmInfo
                          ? categoryItems?.filter(
                              (item) =>
                                item?.title === place?.mkmInfo?.placeList
                            )?.[0]?.icon || categoryItems?.[0]?.icon
                          : categoryItems?.[0]?.icon
                      }
                      alt="Loading"
                    />
                  </div>
                  <div className="like_list">
                    <div
                      className="like_icon"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        removeFromFavorite(place);
                      }}
                    >
                      <IoHeartSharp size="22px" color="#FF8028" />
                      {/* {place?.userFavorite === true ? (
                      <div
                        style={{ color: "#F57D2B" }}
                        
                      >
                        {" "}
                      </div>
                    ) : (
                      <div
                        style={{ color: "#787776" }}
                        // onClick={() =>
                        //   addToFavorite(
                        //     place?.tzadikimID
                        //       ? { tzadikimID: place?.tzadikimID }
                        //       : { mkmID: place?.mkmID },
                        //     place?.userFavorite
                        //   )
                        // }
                      >
                        {" "}
                        <IoHeartOutline size="22px" />
                      </div>
                    )} */}
                      {/* <IoHeart size="22px" color="#FF8028" /> */}
                    </div>
                  </div>

                  <div className="dropdown_list">
                    <Dropdown
                      className="moreInfo"
                      toggle={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        setMenuOpen(index === dropdownMenuOpen ? null : index);
                      }}
                      isOpen={index === dropdownMenuOpen}
                    >
                      <DropdownToggle className="list_icon" caret={false}>
                        <HiDotsVertical className="list" />
                      </DropdownToggle>

                      <DropdownMenu
                        className="custom_dropdown"
                        modifiers={[
                          {
                            name: "offset",
                            options: {
                              offset: [-170, 5],
                            },
                          },
                        ]}
                      >
                        <DropdownItem>
                          <Link
                            to={`/along-the-way-to-here/${
                              place?.tzadikimInfo?.poi
                                ? place?.tzadikimInfo?.poi
                                : place?.mkmInfo?.poi
                            }`}
                            state={{ from: "favourite" }}
                            className="breadcrumb_item1"
                          >
                            <IoNavigateSharp
                              className="navigate_icon"
                              size={"18px"}
                            />
                            <span>Along the way to here</span>
                          </Link>
                        </DropdownItem>
                        <DropdownItem
                          onClick={() =>
                            reportSuggestion(
                              place?.tzadikimInfo?.title
                                ? place?.tzadikimInfo?.title
                                : place?.mkmInfo?.title,
                              place?.tzadikimInfo?.tzadikimID
                                ? { tzkim: place?.tzadikimInfo?.tzadikimID }
                                : { mkm: place?.mkmInfo?.mkmID }
                            )
                          }
                        >
                          <MdOutlineFeedback />
                          Report suggestion
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  </div>

                  <div className="card_top">
                    <div
                      className="left_section"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        share(
                          place?.tzadikimInfo?.tzadikimID
                            ? { tzkim: place?.tzadikimInfo?.tzadikimID }
                            : { mkm: place?.mkmInfo?.mkmID },
                          place?.tzadikimInfo?.poi
                            ? place?.tzadikimInfo?.poi
                            : place?.mkmInfo?.poi
                        );
                      }}
                    >
                      <IoShareSocial />
                    </div>

                    <div className="right_section">
                      {place?.tzadikimInfo?.tzadikimID !== null ? (
                        <Link
                          to={`/category-detail/?tzadikimId=${place?.tzadikimInfo?.tzadikimID}&cor=${place?.tzadikimInfo?.poi}`}
                          state={{
                            from: "favourite",
                            categoryName: "Tzadikim",
                            categoryTitle:
                              place?.tzadikimInfo?.tzadikimID && "צדיקים",
                          }}
                        >
                          <h3>
                            {place?.mkmInfo?.title
                              ? place?.mkmInfo?.title
                              : place?.tzadikimInfo?.title}
                          </h3>
                        </Link>
                      ) : (
                        <Link
                          to={`/category-detail/?MkmId=${place?.mkmInfo?.mkmID}&cor=${place?.mkmInfo?.poi}`}
                          state={{
                            from: "favourite",
                            categoryName: place?.mkmInfo?.mkmID && "Mekomot",
                            categoryTitle: place?.mkmInfo?.mkmID && "מקומות",
                          }}
                        >
                          <h3>
                            {place?.mkmInfo?.title
                              ? place?.mkmInfo?.title
                              : place?.tzadikimInfo?.title}
                          </h3>
                        </Link>
                      )}

                      <Link
                        to={
                          name === "Tzadikim"
                            ? `/category-detail/?tzadikimId=${place?.tzadikimID}&cor=${place?.poi}`
                            : `/category-detail/?MkmId=${place?.mkmID}&cor=${place?.poi}`
                        }
                        state={{
                          categoryName: name,
                          // categoryTitle: categoryTitle,
                          // categoryIcon: categoryIcon,
                        }}
                      >
                        <h3
                          className="card_title"
                          {...(place?.mkmInfo?.place
                            ? place?.mkmInfo?.place
                            : place?.tzadikimInfo?.place)}
                        >
                          {place?.mkmInfo?.place
                            ? place?.mkmInfo?.place
                            : place?.tzadikimInfo?.place}
                        </h3>
                      </Link>
                      <h4>
                        {place?.mkmInfo
                          ? place?.mkmInfo?.cityE + " " + place?.mkmInfo?.stateE
                          : place?.tzadikimInfo?.cityE +
                            " " +
                            place?.tzadikimInfo?.stateE}
                      </h4>
                    </div>
                  </div>
                  <div className="card_location">
                    <div className="location_icon">
                      <FaLocationDot />
                    </div>
                    <div className="place_name">
                      <CardText>
                        {" "}
                        {place?.mkmInfo
                          ? place?.mkmInfo?.cityE + " " + place?.mkmInfo?.stateE
                          : place?.tzadikimInfo?.cityE +
                            " " +
                            place?.tzadikimInfo?.stateE}
                      </CardText>
                    </div>
                  </div>

                  <div className="card_buttons">
                    <Button
                      className="btn_explore"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <Link
                        style={{ color: "#F57D2B" }}
                        to={`/explore-near-by/${
                          place?.tzadikimInfo?.poi
                            ? place?.tzadikimInfo?.poi
                            : place?.mkmInfo?.poi
                        }`}
                        state={{ from: "favourite" }}
                      >
                        Explore Near By
                      </Link>
                    </Button>

                    {place?.tzadikimInfo &&
                    place?.tzadikimInfo?.tzadikimID !== null ? (
                      <Link
                        className="btns_viewmore"
                        to={`/category-detail/?tzadikimID=${place?.tzadikimInfo}&cor=${place?.tzadikimInfo?.poi}`}
                        state={{
                          from: "favourite",
                          categoryName:
                            place?.tzadikimInfo?.tzadikimID && "Tzadikim",
                          categoryItems:
                            place?.tzadikimInfo?.tzadikimID && "צדיקים",
                        }}
                        onClick={(e) => e.stopPropagation()}
                      >
                        View More
                      </Link>
                    ) : (
                      <Link
                        className="btns_viewmore"
                        to={`/category-detail/?MkmId=${place?.mkmInfo?.mkmID}&cor=${place?.mkmInfo?.poi}`}
                        state={{
                          from: "favourite",
                          categoryName: place?.mkmInfo?.mkmID && "Mekomot",
                          categoryTitle: place?.mkmInfo?.mkmID && "מקומות",
                        }}
                        onClick={(e) => e.stopPropagation()}
                      >
                        View More
                      </Link>
                    )}

                    <Button
                      className="btn_addroute"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        addToRoute(place?.mkmID, place);
                      }}
                    >
                      <FaPlus className="addroute_icon" />
                      Add to Route
                    </Button>
                  </div>
                </div>
              </Link>
            </div>
          ))
        )}
      </div>

      {/* <Row>
        {isUserLoggedIn ? (
          <>
            {currentTableData?.length === 0 ? (
              <NoDataFound />
            ) : (
              currentTableData?.map((item, index) => (
                <Col className="mt-4" xxl="4" lg="6" md="12" key={index}>
                  <Card body>
                    <div className="card_header">
                      <Button className="favourite_fill_icon">
                        <AiFillStar size={20} />
                      </Button>
                      <div className="right_section">
                        {console.log("klwnfjkweq", item)}
                        {item?.tzadikimInfo?.tzadikimID !== null ? (
                          <Link
                            to={`/category-detail/?tzadikimId=${item?.tzadikimInfo?.tzadikimID}&cor=${item?.tzadikimInfo?.poi}`}
                            state={{
                              from: "favourite",
                              categoryName: "Tzadikim",
                              categoryTitle:
                                item?.tzadikimInfo?.tzadikimID && "צדיקים",
                            }}
                          >
                            <CardTitle tag="h5">
                              {item?.mkmInfo?.title
                                ? item?.mkmInfo?.title
                                : item?.tzadikimInfo?.title}
                            </CardTitle>
                          </Link>
                        ) : (
                          <Link
                            to={`/category-detail/?MkmId=${item?.mkmInfo?.mkmID}&cor=${item?.mkmInfo?.poi}`}
                            state={{
                              from: "favourite",
                              categoryName: item?.mkmInfo?.mkmID && "Mekomot",
                              categoryTitle: item?.mkmInfo?.mkmID && "מקומות",
                            }}
                          >
                            <CardTitle tag="h5">
                              {item?.mkmInfo?.title
                                ? item?.mkmInfo?.title
                                : item?.tzadikimInfo?.title}
                            </CardTitle>
                          </Link>
                        )}
                        <Dropdown
                          className="moreInfo"
                          toggle={() =>
                            setMenuOpen(
                              index === dropdownMenuOpen ? null : index
                            )
                          }
                          isOpen={index === dropdownMenuOpen}
                        >
                          <DropdownToggle>
                            <BiDotsVerticalRounded size={20} />
                          </DropdownToggle>
                          <DropdownMenu className="favourites_drop-down">
                            <DropdownItem>
                              <Link
                                to={`/along-the-way-to-here/${
                                  item?.tzadikimInfo?.poi
                                    ? item?.tzadikimInfo?.poi
                                    : item?.mkmInfo?.poi
                                }`}
                                state={{ from: "favourite" }}
                                className="breadcrumb_item1"
                              >
                                Along the way to here
                              </Link>
                            </DropdownItem>
                            <DropdownItem
                              onClick={() =>
                                reportSuggestion(
                                  item?.tzadikimInfo?.title
                                    ? item?.tzadikimInfo?.title
                                    : item?.mkmInfo?.title,
                                  item?.tzadikimInfo?.tzadikimID
                                    ? { tzkim: item?.tzadikimInfo?.tzadikimID }
                                    : { mkm: item?.mkmInfo?.mkmID }
                                )
                              }
                            >
                              Report suggestion
                            </DropdownItem>
                            <DropdownItem
                              onClick={() => removeFromFavorite(item)}
                            >
                              Remove from favourites
                            </DropdownItem>
                          </DropdownMenu>
                        </Dropdown>
                      </div>
                    </div>
                    <CardText className="grid_text_le">
                      {item?.mkmInfo?.stateY
                        ? item?.mkmInfo?.stateY
                        : item?.tzadikimInfo?.nfInfo}{" "}
                    </CardText>
                    <div className="card_bottom">
                      <Button
                        onClick={() =>
                          share(
                            item?.tzadikimInfo?.tzadikimID
                              ? { tzkim: item?.tzadikimInfo?.tzadikimID }
                              : { mkm: item?.mkmInfo?.mkmID },
                            item?.tzadikimInfo?.poi
                              ? item?.tzadikimInfo?.poi
                              : item?.mkmInfo?.poi
                          )
                        }
                      >
                        <FiShare2 size={20} />
                      </Button>
                      <div className="right_section">
                        <CardText>
                          {item?.mkmInfo
                            ? item?.mkmInfo?.cityE + " " + item?.mkmInfo?.stateE
                            : item?.tzadikimInfo?.cityE +
                              " " +
                              item?.tzadikimInfo?.stateE}
                        </CardText>
                        <MdLocationOn className="location_icon" size={18} />
                      </div>
                    </div>
                    <div className="card_footer">
                      <Link
                        to={`/explore-near-by/${
                          item?.tzadikimInfo?.poi
                            ? item?.tzadikimInfo?.poi
                            : item?.mkmInfo?.poi
                        }`}
                        state={{ from: "favourite" }}
                        className="btn explore"
                      >
                        <BiExitFullscreen className="explore_icon" />
                        Explore Near By
                      </Link>
                      {item?.tzadikimInfo &&
                      item?.tzadikimInfo?.tzadikimID !== null ? (
                        <Link
                          to={`/category-detail/?tzadikimId=${item?.tzadikimInfo?.tzadikimID}&cor=${item?.tzadikimInfo?.poi}`}
                          state={{
                            from: "favourite",
                            categoryName:
                              item?.tzadikimInfo?.tzadikimID && "Tzadikim",
                            categoryTitle:
                              item?.tzadikimInfo?.tzadikimID && "צדיקים",
                          }}
                          className="btn viewmore"
                        >
                          View More
                        </Link>
                      ) : (
                        <Link
                          to={`/category-detail/?MkmId=${item?.mkmInfo?.mkmID}&cor=${item?.mkmInfo?.poi}`}
                          state={{
                            from: "favourite",
                            categoryName: item?.mkmInfo?.mkmID && "Mekomot",
                            categoryTitle: item?.mkmInfo?.mkmID && "מקומות",
                          }}
                          className="btn viewmore"
                        >
                          View More
                        </Link>
                      )}
                      <Button
                        className="btn addroute"
                        onClick={() =>
                          addToRoute(
                            item?.tzadikimInfo?.tzadikimID
                              ? item?.tzadikimInfo?.tzadikimID
                              : item?.mkmInfo?.mkmID
                          )
                        }
                      >
                        <FiBriefcase className="addroute_icon" />
                        Add to Route
                      </Button>
                    </div>
                  </Card>
                </Col>
              ))
            )}
          </>
        ) : (
          <UserNotLoggedIn />
        )}
      </Row> */}
      {isUserLoggedIn ? (
        <>
          {currentTableData?.length === 0 ||
          currentTableData === undefined ? null : (
            <Pagination
              className="pagination-bar"
              currentPage={currentPage}
              totalCount={totalRecords > 0 ? totalRecords : null}
              pageSize={pageSize}
              onPageChange={(currentPage) => setCurrentPage(currentPage)}
            />
          )}
        </>
      ) : null}
    </div>
  );
};
export default GridView;
